import { render, staticRenderFns } from "./DispensaSetor.vue?vue&type=template&id=2ab1577f"
import script from "./DispensaSetor.vue?vue&type=script&lang=js"
export * from "./DispensaSetor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports